export default {
  process: {
    step1: '棚の配置',
    step2: '要素のレイアウト',
    step3: 'ゲームプレイ設定',
    next: '次へ',
    previous: '前へ',
    finish: '完了',
  },
  step1: {
    setting1: {
      title: '棚の行列',
      rowCol: '行と列',
      row: '行',
      col: '列',
      reverse: '[行-列数] 横向き/縦向きに切り替え',
      reverseTip:
        '選択後、縦横画面のグリッド番号は以下のように配置されます：\n縦画面のグリッド番号は：<br/>1 2<br/>3 4<br/>5 6<br/>横画面のグリッド番号は：<br/>1 3 5<br/>2 4 6',
      layout: '配置形式',
      align: '行列対齊',
      colDisLocation: '列のズレ',
      rowDisLocation: '行のズレ',
    },
    setting2: {
      title: '棚',
      gridSize: '格子',
      followGridImg: 'グリッド画像で表示',
      wholeSize: '全体サイズ',
      gridImg: 'グリッド画像',
      gridImgUpload: 'グリッド画像をアップロードしてください',
      shelvesImg: 'シェルフ画像',
      shelvesImgUpload: 'シェルフ画像をアップロードしてください',
      shelvesPivot: 'シェルフアンカー',
      shelvesPivotDesc:
        '緑の点はグリッドです。<br/>シェルフの位置を調整するために、緑の点を移動できます。',
    },
  },
  step2: {
    setting1: {
      title: 'シングルグリッド設定',
      goodsNum: '各グリッドの要素数',
      padding: '内部余白',
      left: '左',
      right: '右',
      up: '上',
      down: '下',
    },
    setting2: {
      goods: '要素',
      selectGoods: '要素画像を選択してください',
      error: '現在の数量では全てを消去することがきません',
    },
    setting3: {
      title: '詳細設定',
      weight: 'ウエイト調整',
      highlight: 'アウターグロー',
      blur: 'ぼかし',
      preview: 'プレビューのスタイル',
      closePreview: 'プレビューを閉じる',
      apply: '設定を適用',
      weightErrorTip:
        'ウエイトの合計を100％にする必要があります。再構成してください',
    },
  },
  step3: {
    setting1: {
      title: '特定のゲームプレイグリッド',
      addBtn: '特定のゲームプレイグリッドを追加',
      grid: 'グリッド',
    },
    setting2: {
      title: '消去後のグリッド状態',
      reserve: 'グリッド保持',
      reserveEff: '保持効果',
      close: '閉じる',
      noClose: '閉じない',
      closeImage: '画像を閉じる',
      uploadCloseImage: '閉じる画像をアップロードしてください',
      closeImageTip:
        '画像を選択した後、キャンバスでデフォルトで閉じているグリッドを選択できます。これらのグリッドはゲーム開始時に閉じた状態で表示されます。',
      remove: 'グリッド消去',
      removeEff: '落下ゲームプレイ',
      fall: '落下',
      noFall: '落下しない',
    },
    setting3: {
      title: 'フロントエンドデフォルト値',
      remove: '消去',
      noRemove: '消去しない',
      closeOrNot: '閉じられているか確認',
      fallTitle: '上のグリッドの落下',
      fall: '落下',
      noFall: '落下しない',
    },
  },
}
